import * as React from "react";
import { Link } from "react-router-dom";
import { CloseButton, Col, Image, Row } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { Account, AdminUIActionTypes } from "src/common";
import { Icon } from "src/components";
import img from "src/assets/images/welcome-admin.svg";

type AllProps = {
  current_account: Account;
  handleAction: ActionHandlerFunction;
}

function DashboardWelcomeComponent(props: AllProps) {
  const { current_account, handleAction } = props;
  const username = current_account.display_name;

  function checkmarkAndLink(link: string, title: string, state?: { default_active_tab: string }) {
    return (
      <div>
        <Icon className="icon-checkmark" />
        <Link to={link} state={state ? { default_active_tab: "assign" } : undefined}>{title}</Link>
      </div>
    );
  }

  // Description: Render the welcome component. Only render if the drive storage is empty.
  return (
    <div className="dashboard-welcome">
      <CloseButton className="close-button" onClick={() => handleAction({ actionType: AdminUIActionTypes.Close })} />
      <h3 className="mb-1">Welcome {username}!</h3>
      <p>The following are a few links to help you get started.</p>
      <Row>
        <Col lg={6}>
          <h5>Get Started</h5>
          <div>
            {checkmarkAndLink("/admin/users", "Create Users")}
          </div>
          <div>
            {checkmarkAndLink("/admin/approval-groups", "Create Approval Groups")}
          </div>
        </Col>
        <Col lg={6}>
          <h5>Next Steps</h5>
          <div>
            {checkmarkAndLink("/admin/approval-groups", "Assign Approval Groups", { default_active_tab: "assign" })}
          </div>
          <div>
            {checkmarkAndLink("/admin/users", "Set User Default Settings")}
          </div>
        </Col>
      </Row>
      <Image alt="PreVeil Logo" src={img} className="welcome-admin-image" />
    </div>
  );
}

export default React.memo(DashboardWelcomeComponent);
